import { Box, useMediaQuery, useTheme } from '@mui/material';
import LogoSrc from '../../../../../assets/Morrison_logo.svg';

function HeaderLogoMorrison() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const logoSrc = LogoSrc;
  return (
    <Box
      component={'img'}
      src={logoSrc}
      alt="Morrisons Logo"
      sx={(theme) => ({
        fontSize: isMobile ? '0.6rem' : undefined,
        height: '2.5rem',
        maxWidth: '150px',
        color: theme.palette.text.primary,
      })}
    />
  );
}

export default HeaderLogoMorrison;
